module.exports = __webpack_public_path__ + "img/vlovemother-banner-pc.38d82999.jpg";